import { useContext } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSettings } from 'state/Settings'
import { FMT, klass } from 'utils'
import OrderContext from '../_context'
import Ellipsis from './Ellipsis'

/**
 * @param temp
 * @param isCompleted
 * @param isCancelled
 * @return {JSX.Element}
 */
export default function DatesRow({ temp, isCompleted, isCancelled }) {
	const { t } = useTranslation()

	/** @type Order */
	const order               = useContext(OrderContext)
	const { enableCompleted } = useSettings()
	const relativeClassName   = (!enableCompleted || !isCompleted) && !isCancelled? order.timeStatus.class : ''

	return <Row id="dates-row">
		<Col xs="auto">
			<span className="d-flex align-items-center mr-0">{order.readyAtFormatted(true, true)}</span>
			<small className="text-muted">
				{temp?
					<Ellipsis size="1x"/> :
					<>{t('Placed {{date}}', { date: FMT.date(order.created_at, { forceDate: order.ready_at }), context: 'When order was created'})}</>}
			</small>
		</Col>

		<Col>
			{isCompleted?
				<>
					<label>{t('Completed')}</label>
					<span {...klass(relativeClassName, 'text-nowrap')}>{FMT.date(order.modified_at)}</span>
				</>
				:
				<strong {...klass(relativeClassName, 'd-flex align-items-center d-print-none', { 'textStrike textMuted': isCancelled })}>
					<order.comp.dueTime withIcon/> <order.comp.isAsap/>
				</strong>
			}
		</Col>
	</Row>
}
